import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import Cookies from "js-cookie";

const LangselectComponent = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
  }, [])

  return (
    <>
      {!Cookies.get('language') || Cookies.get('language') == 'hu' &&
        <Button icon="pi pi-globe"
                iconPos="right"
                onClick={() => {
                  window.App.changeLanguage('en')
                  window.App.forceUpdate()
                }}
                className={"p-button-link"}
                label={"English"}
        />
      }
      {Cookies.get('language') == 'en' &&
        <Button icon="pi pi-globe"
                iconPos="right"
                onClick={() => {
                  window.App.changeLanguage('hu')
                  window.App.forceUpdate()
                }}
                className={"p-button-link"}
                label={"Magyar"}
        />
      }
    </>
  )
}
export default withTranslation('common')(LangselectComponent);
